export const LIBRARY_PAGE_PATH = "/library/";
export const SHARED_WITH_ME_PAGE_PATH = `${LIBRARY_PAGE_PATH}shared-with-me/`;
